<template>
  <!-- Modal -->
    <div class="modal fade" id="newsletters" tabindex="-1" role="dialog" aria-labelledby="newslettersTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
        <div class="modal-header border-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body text-center">
            <div>
              <h5 class="modal-title pb-2" id="registeredTitle"><strong id="response">Manage your newsletter subscription</strong></h5>
              <p class="pb-3">Enter the email address associated with your subscription followed by any additional preferences.</p>
              <p>
                <small>Confirm your email</small> <br>
                <input v-model="email" size="29" type="email" class="email-input">
              </p>
            </div>
            <div v-if="opt_in_daily" class="form-check form-check-inline">
              <input v-model="preference" class="form-check-input" type="radio" name="inlineRadioOptions" id="newsRadio1" value="opt_in_daily">
              <label class="form-check-label" for="newsRadio1">Daily</label>
            </div>
            <div v-if="opt_in_weekly" class="form-check form-check-inline">
              <input v-model="preference" class="form-check-input" type="radio" name="inlineRadioOptions" id="newsRadio2" value="opt_in_weekly">
              <label class="form-check-label" for="newsRadio2">Weekly</label>
            </div>
            <div v-if="opt_in_monthly" class="form-check form-check-inline">
              <input v-model="preference" class="form-check-input" type="radio" name="inlineRadioOptions" id="newsRadio3" value="opt_in_monthly">
              <label class="form-check-label" for="newsRadio3">Monthly</label>
            </div>
            <div v-if="opt_in_yearly" class="form-check form-check-inline">
              <input v-model="preference" class="form-check-input" type="radio" name="inlineRadioOptions" id="newsRadio4" value="opt_in_yearly">
              <label class="form-check-label" for="newsRadio4">Yealry</label>
            </div>
            <div class="form-check form-check-inline">
              <input v-model="preference" class="form-check-input" type="radio" name="inlineRadioOptions" id="newsRadio5" value="unsubscribe">
              <label class="form-check-label" for="newsRadio5">Unsubscribe</label>
            </div>
        </div>
        <div v-if="test" class="modal-footer">
            <button v-if="response===null" type="button" v-on:click="validate()" class="btn btn-secondary btn-block rounded-0">Confirm your changes</button>
            <button v-else type="button" class="btn btn-success btn-block" data-dismiss="modal">Request sent. Close</button>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Newsletter',
  props: {
    api: String,
    location: String,
    opt_in_yearly: Boolean,
    opt_in_monthly: Boolean,
    opt_in_weekly: Boolean,
    opt_in_daily: Boolean,
  },
  data: () => ({
    email: null,
    preference: null,
    response: null,
  }),
  methods: {
    validate() {
      axios.post(this.api+'api/v1/listing/newsletter', {
         email: this.email,
          location: this.location,
          newsletter_daily: this.opt_in_daily,
          newsletter_weekly: this.opt_in_weekly,
          newsletter_monthly: this.opt_in_monthly,
          newsletter_yearly: this.opt_in_yearly,
          preference: this.preference
      }).then((res)=>{ 
        if (res.data.result) {
          this.response='finish';
        } else {
          this.response='oops';
        }
      }).catch(() => { console.error("Updating newsletter subscription preferences failed!");});
    },
    validEmail(email) {
        if (email===null) return;
        let regExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        //return !!email.match(regExp);
        if (this.email.match(regExp)) {
            return true;
        } else {
            return false;
        }
    },
    mounted() {
      //if (this.exired) this.proceed='expired'; // obsolete
    },
  },
  computed: {
      test: function() {
        if (this.email===null||this.email.length<5) return false;
        let regExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        if (this.email.match(regExp)) {
            return true;
        } else {
            return false;
        }
      }
    },
}
</script>


<style scoped>
    .email-input {
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom: 1px solid grey;
        margin-bottom: 12px;
    }
</style>
